import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram, User } from 'lucide-react';
import PageTransition from '../components/PageTransition';
import { TEAM_MEMBERS } from '../data';
import './TeamPage.css';

const DEPARTMENTS = ['Tümü'];

const DEPT_STYLES = {
  Yönetim:  { bg: 'linear-gradient(135deg,#c0392b,#d35400)', text: '#fefefe' },
  a: { bg: '#fde8d8', text: '#ab130b8a' },
};

function MemberCard({ member, size = 'normal', index = 0 }) {
  const ds = DEPT_STYLES[member.department] || { bg: '#f0eeed', text: '#4a4540' };
  return (
    <motion.div
      className={`team-card team-card-${size}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.07 }}
    >
      <div className="team-avatar">
        {member.photo
          ? <img src={member.photo} alt={member.name} />
          : <User size={size === 'large' ? 32 : size === 'normal' ? 24 : 20} />
        }
      </div>
      <div className="team-info">
        <h3>{member.name}</h3>
        <span
          className="team-role-badge"
          style={{ background: ds.bg, color: ds.text }}
        >
          {member.role}
        </span>
        {size !== 'small' && <p>{member.bio}</p>}
      </div>
      <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-btn" aria-label="Instagram">
        <Instagram size={14} />
      </a>
    </motion.div>
  );
}

export default function TeamPage() {
  const [filter, setFilter] = useState('Tümü');

  const filtered = filter === 'Tümü'
    ? TEAM_MEMBERS
    : TEAM_MEMBERS.filter(m => m.department === filter);

  const tier1 = filtered.filter(m => m.tier === 1);
  const tier2 = filtered.filter(m => m.tier === 2);
  const tier3 = filtered.filter(m => m.tier === 3);

  return (
    <PageTransition>
      <div className="team-page">

        <section className="page-hero">
          <div className="page-hero-bg" />
          <div className="container page-hero-content">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <span className="section-tag">Ekibimiz</span>
              <h1>Arkasındaki İnsanlar</h1>
              <p>Çamlıca Çalıştay'ı hayata geçiren tutkulu lise öğrencisi organizatörlerimizle tanışın.</p>
            </motion.div>
          </div>
        </section>

        <section className="team-main">
          <div className="container">
            <div className="team-filter">
              {DEPARTMENTS.map(d => (
                <button key={d} className={`filter-btn ${filter === d ? 'active' : ''}`} onClick={() => setFilter(d)}>
                  {d}
                </button>
              ))}
            </div>

            {tier1.length > 0 && (
              <div className="team-tier">
                <div className="tier-label"><span>Yönetim Kurulu</span></div>
                <div className="tier-grid tier-1-grid">
                  {tier1.map((m, i) => <MemberCard key={m.id} member={m} size="large" index={i} />)}
                </div>
              </div>
            )}

            {tier1.length > 0 && tier2.length > 0 && (
              <div className="org-connector"><div className="connector-line" /></div>
            )}

            {tier2.length > 0 && (
              <div className="team-tier">
                <div className="tier-label"><span>Ekip Üyeleri</span></div>
                <div className="tier-grid tier-2-grid">
                  {tier2.map((m, i) => <MemberCard key={m.id} member={m} size="normal" index={i} />)}
                </div>
              </div>
            )}

            {tier2.length > 0 && tier3.length > 0 && (
              <div className="org-connector"><div className="connector-line" /></div>
            )}

            {tier3.length > 0 && (
              <div className="team-tier">
                <div className="tier-label"><span>Ekip Üyeleri</span></div>
                <div className="tier-grid tier-3-grid">
                  {tier3.map((m, i) => <MemberCard key={m.id} member={m} size="small" index={i} />)}
                </div>
              </div>
            )}

            {filtered.length === 0 && (
              <div className="no-results">Bu departmanda ekip üyesi bulunamadı.</div>
            )}
          </div>
        </section>

      </div>
    </PageTransition>
  );
}
